import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { Parcel } from '@/types'

interface ParcelsResponse {
  data: Parcel[]
}

export function useParcels(status?: 'pending' | 'collected') {
  return useQuery({
    queryKey: ['customer', 'parcels', status],
    queryFn: async () => {
      const params = status ? { status } : {}
      const response = await api.get<ParcelsResponse>('/api/customer/parcels', { params })
      return response.data.data
    },
  })
}
